import React from 'react';

import NxtWaveLogoWhite from '../../icons/NxtWaveWhiteLogoSvg';

import ChecklistWithTitle from './ChecklistWithTitle';
import RegisterButton from './RegisterButton';
import { LogoContainer } from './StyleComponent';

export const NxtwaveWhiteLogo: React.FC = () => {
  return (
    <LogoContainer className="nxtwave-white-logo">
      <NxtWaveLogoWhite />
    </LogoContainer>
  );
};

export { ChecklistWithTitle, RegisterButton };
